import React from 'react';
import '../styles/TeacherToolbelt.css';

interface TeacherToolbeltProps {
    onRewardClick?: () => void;
    onUnlockClick?: () => void;
    onManageGamesClick?: () => void;
    onReportBugClick: () => void;
    onTimerClick: () => void;
    onBonusActivitiesClick?: () => void;
    onOGCreateClick?: () => void;
    onMusicClick?: () => void;
    onBoardModeClick?: () => void;
    isUnlocking?: boolean;
}

const TeacherToolbelt: React.FC<TeacherToolbeltProps> = ({
    onRewardClick,
    onUnlockClick,
    onManageGamesClick,
    onReportBugClick,
    onTimerClick,
    onBonusActivitiesClick,
    onOGCreateClick,
    onMusicClick,
    onBoardModeClick,
    isUnlocking = false,
}) => {
    return (
        <div className="teacher-toolbelt-container">
            <div className="teacher-toolbelt">
                <div className="toolbelt-main-title">Teacher's Toolbelt</div>
                {onManageGamesClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button"
                            onClick={onManageGamesClick}
                            title="Manage Games"
                        >
                            <span className="toolbelt-emoji">🔓</span>
                        </button>
                        <span className="toolbelt-label">Games</span>
                    </div>
                )}

                {onOGCreateClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button"
                            onClick={onOGCreateClick}
                            title="OG Prompt Create"
                        >
                            <span className="toolbelt-emoji">🧙‍♂️</span>
                        </button>
                        <span className="toolbelt-label">Create</span>
                    </div>
                )}

                {onBoardModeClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button"
                            onClick={onBoardModeClick}
                            title="Reflection"
                        >
                            <span className="toolbelt-emoji">📝</span>
                        </button>
                        <span className="toolbelt-label">Reflect</span>
                    </div>
                )}

                <div className="toolbelt-item-wrapper">
                    <button
                        className="toolbelt-button"
                        onClick={onTimerClick}
                        title="Timer"
                    >
                        <span className="toolbelt-emoji">⏰</span>
                    </button>
                    <span className="toolbelt-label">Timer</span>
                </div>

                {onBonusActivitiesClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button"
                            onClick={onBonusActivitiesClick}
                            title="Bonus Activities"
                        >
                            <span className="toolbelt-emoji">🏃</span>
                        </button>
                        <span className="toolbelt-label">Bonus</span>
                    </div>
                )}

                {onRewardClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button reward-button"
                            onClick={onRewardClick}
                            title="Give Reward"
                        >
                            <span className="toolbelt-emoji">💰</span>
                        </button>
                        <span className="toolbelt-label">Reward</span>
                    </div>
                )}

                <div className="toolbelt-item-wrapper">
                    <button
                        className="toolbelt-button"
                        onClick={onReportBugClick}
                        title="Report Bug"
                    >
                        <span className="toolbelt-emoji">🐛</span>
                    </button>
                    <span className="toolbelt-label">Bug</span>
                </div>

                {onMusicClick && (
                    <div className="toolbelt-item-wrapper">
                        <button
                            className="toolbelt-button"
                            onClick={onMusicClick}
                            title="Music"
                        >
                            <span className="toolbelt-emoji">🎵</span>
                        </button>
                        <span className="toolbelt-label">Music</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeacherToolbelt;
